const { toArray, compact } = require('lodash');

class CheckoutConfirmationOrderPaymentBreakdownController {
    $onInit() {
        this.shouldShowBreakdownAmount = compact(toArray(this.order.PaymentBreakdown)).length > 1;
    }
}

const checkoutConfirmationOrderPaymentBreakdownControllerComponentDefinition = {
    bindings: {
        order: '<',
    },
    controller: [CheckoutConfirmationOrderPaymentBreakdownController],
    template: require('./checkout-confirmation-order-payment-breakdown.component.html').trim(),
};

module.exports = {
    CheckoutConfirmationOrderPaymentBreakdownController,
    checkoutConfirmationOrderPaymentBreakdownControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/confirmation/checkout-confirmation-order-payment-breakdown.component.js